import { render, staticRenderFns } from "./cargo_item_1.vue?vue&type=template&id=291b4345&scoped=true"
import script from "./cargo_item_1.vue?vue&type=script&lang=js"
export * from "./cargo_item_1.vue?vue&type=script&lang=js"
import style0 from "./cargo_item_1.vue?vue&type=style&index=0&id=291b4345&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291b4345",
  null
  
)

export default component.exports